
  export default {
    props: {
      data: {
        type: [Object, null],
        default: null,
      },
    },
  };
